export const howWeTeach = {
  title: "Comment Nous Enseignons",
  subtitle: "Méthodologies qui guident notre quotidien",
  items: {
    active: {
      title: "Pédagogie Active / Montessori",
      description: "L'enfant comme protagoniste de son apprentissage à travers des environnements préparés et des matériels manipulatifs"
    },
    global: {
      title: "Apprentissage Global en Anglais",
      description: "Immersion progressive: 40% en Maternelle, 45% en Cycle 1, 50% en Cycle 2, avec zones non linguistiques en anglais"
    },
    inclusion: {
      title: "Inclusion (CUA)",
      description: "Conception Universelle de l'Apprentissage qui garantit l'accessibilité et respecte la diversité de chaque élève"
    },
    evaluation: {
      title: "Évaluation Bienveillante",
      description: "Données bienveillantes: observation, documentation pédagogique et feedback qui accompagne sans étiqueter"
    }
  }
};
